var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5.16671C11.9999 4.43137 11.4019 3.83337 10.6666 3.83337H2.66659C1.93125 3.83337 1.33325 4.43137 1.33325 5.16671V11.8334C1.33325 12.5687 1.93125 13.1667 2.66659 13.1667H10.6666C11.4019 13.1667 11.9999 12.5687 11.9999 11.8334V9.61137L14.6666 11.8334V5.16671L11.9999 7.38871V5.16671ZM10.6679 11.8334H2.66659V5.16671H10.6666L10.6673 8.49937V8.50071L10.6679 11.8334Z",
    fill: "#0688FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.487e32656cbfe503f8b9652de31ece27.svg";
export { ForwardRef as ReactComponent };